goog.provide("shadow.js.shim.module$date_fns$locale$es$default");
shadow.js.shim.module$date_fns$locale$es$default = esm_import$date_fns$locale$es.default;
